<template>
	<div class="staff-staff-form-permissions">
		<input-checkbox v-model="model.profile" name="permissions_profile" placeholder="Profile"/>
		<hr>
		<input-checkbox v-model="model.devices" name="permissions_devices" placeholder="Devices"/>
		<input-checkbox v-model="model.devices_add_group" name="permissions_devices_add_group" placeholder="Devices Add Group"/>
		<input-checkbox v-model="model.devices_edit_group" name="permissions_devices_edit_group" placeholder="Devices Edit Group"/>
		<input-checkbox v-model="model.devices_delete_group" name="permissions_devices_delete_group" placeholder="Devices Delete Group"/>
		<input-checkbox v-model="model.devices_add_device" name="permissions_devices_add_device" placeholder="Devices Add Device"/>
		<hr>
		<input-checkbox v-model="model.patients" name="permissions_patients" placeholder="Patients"/>
		<input-checkbox v-model="model.patients_add_group" name="permissions_patients_add_group" placeholder="Patients Add Group"/>
		<input-checkbox v-model="model.patients_edit_group" name="permissions_patients_edit_group" placeholder="Patients Edit Group"/>
		<input-checkbox v-model="model.patients_delete_group" name="permissions_patients_delete_group" placeholder="Patients Delete Group"/>
		<input-checkbox v-model="model.patients_add_patient" name="permissions_patients_add_patient" placeholder="Patients Add Patient"/>
	</div>
</template>

<script>
import InputCheckbox from './InputCheckbox'
export default {
	components: {
		InputCheckbox
	},
	props: [
		'user_uid',
		'permissions'
	],
	data () {
		return {
			model: {
				profile: false,
				devices: false,
				devices_add_group: false,
				devices_edit_group: false,
				devices_delete_group: false,
				devices_add_patient: false,
				patients: false,
				patients_add_group: false,
				patients_edit_group: false,
				patients_delete_group: false,
				patients_add_patient: false
			}
		}
	},
	watch: {
		permissions: {
			handler (value) {
				if (Array.isArray(value)) {
					value.forEach(element => {
						this.model[element] = true
					})
				}
			},
			deep: true,
			immediate: true
		},
		model: {
			handler () {
				const permissions = []
				for (let key in this.model) {
					if (this.model[key]) {
						permissions.push(key)
					}
				}
				this.$emit('permissionsUpdate', this.user_uid, permissions)
			},
			deep: true,
			immediate: true
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/staff/components/StaffStaffFormPermissions.vue